import { Avatar } from "../Atoms";
import { PJ_ROLES } from "../../constants";

// Quien hace un paso y a quien se le pregunta.
//
// Vive aparte porque lo usan dos sitios que tienen que ofrecer EXACTAMENTE lo
// mismo: el formulario de crear un paso y la fila desplegable de la lista. Si
// uno de los dos se queda corto, el usuario acaba buscando "el sitio donde si se
// puede", que es justo lo que pasaba cuando editar de verdad exigia abrir el
// modal del lapiz.
//
// `valor` es { encargado: [ids], responsable: [ids], participante: [ids] } y se
// devuelve entero en cada cambio: son tres listas cortas y reconstruirlas es mas
// barato que razonar sobre parches.
// `id` y `aria-labelledby` los pone <Campo> cuando el editor es el campo de una
// etiqueta: el grupo queda nombrado por ella («Quien lo hace y a quien preguntar»).
export default function AsignacionesEditor({
  valor, onChange, users = [], miembros = [], disabled = false, alto = 190,
  id, "aria-labelledby": labelledBy,
}) {
  // Se ofrece primero a la gente del proyecto: asignar un paso a alguien de
  // fuera es lo raro, no lo normal.
  const idsMiembros = new Set((miembros || []).map(m => String(m.user_id)));
  const lista = [
    ...users.filter(u => idsMiembros.has(String(u.id))),
    ...users.filter(u => !idsMiembros.has(String(u.id))),
  ];

  const alternar = (rol, userId) => {
    if (disabled) return;
    const id = String(userId);
    const dentro = (valor[rol] || []).some(x => String(x) === id);
    onChange({
      ...valor,
      [rol]: dentro
        ? valor[rol].filter(x => String(x) !== id)
        : [...(valor[rol] || []), id],
    });
  };

  if (!lista.length) {
    return (
      <div style={{ fontSize: 11, color: "var(--text3)", padding: "8px 10px",
        border: "1px solid var(--border)", borderRadius: 9 }}>
        No hay nadie a quien asignar todavia.
      </div>
    );
  }

  return (
    <div id={id} role="group" aria-labelledby={labelledBy}
      style={{ maxHeight: alto, overflowY: "auto", border: "1px solid var(--border-ctl)",
      borderRadius: 9, opacity: disabled ? 0.6 : 1 }}>
      {lista.map(u => {
        const esDelProyecto = idsMiembros.has(String(u.id));
        return (
          <div key={u.id} style={{ display: "flex", alignItems: "center", gap: 8,
            padding: "6px 9px", borderBottom: "1px solid var(--border2)",
            opacity: esDelProyecto ? 1 : .62 }}>
            <Avatar name={u.name} size={22} />
            <span style={{ flex: 1, fontSize: 12, color: "var(--text2)" }}>
              {u.name}
              {!esDelProyecto && (
                <span style={{ fontSize: 9.5, color: "var(--text3)" }}> · fuera del proyecto</span>
              )}
            </span>
            {PJ_ROLES.map(r => {
              const on = (valor[r.key] || []).some(x => String(x) === String(u.id));
              return (
                // Cada boton se llama «Encargado: Ana» (el texto solo, repetido por cada
                // persona, no dice a quien se asigna) y dice si esta puesto.
                <button key={r.key} className="btn" title={r.sub} disabled={disabled}
                  aria-label={`${r.label}: ${u.name}`} aria-pressed={on}
                  onClick={() => alternar(r.key, u.id)}
                  style={{ padding: "3px 7px", borderRadius: 6, fontSize: 10,
                    cursor: disabled ? "not-allowed" : "pointer",
                    fontFamily: "var(--font)", fontWeight: on ? 700 : 500,
                    border: `1px solid ${on ? "var(--accent)" : "var(--border-ctl)"}`,
                    background: on ? "var(--accent-bg)" : "var(--surface)",
                    color: on ? "var(--accent)" : "var(--text3)" }}>
                  {r.label}
                </button>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}

// El mismo dato en las dos formas en que viaja: la tarea lo trae como lista de
// {user_id, rol} y los formularios lo manejan como tres listas de ids.
export const asignacionesDe = (tarea) => {
  const m = { encargado: [], responsable: [], participante: [] };
  (tarea?.asignados || []).forEach(a => { if (m[a.rol]) m[a.rol].push(String(a.user_id)); });
  return m;
};

// Lo que espera el backend: encargados / responsables / participantes.
export const aPayload = (valor) => ({
  encargados:    valor.encargado    || [],
  responsables:  valor.responsable  || [],
  participantes: valor.participante || [],
});
